"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceUserFieldsFragment = void 0;
var tslib_1 = require("tslib");
/**
 * Utility function used to modify the current query Document.
 * We remove the existing the user fragment and add the one provided by the user.
 * Graphql-codegen add the fragment as the end of the definition array.
 */
exports.replaceUserFieldsFragment = function (document, userFieldsFragment) {
    return tslib_1.__assign(tslib_1.__assign({}, document), { definitions: tslib_1.__spreadArrays(document.definitions.slice(0, -1), userFieldsFragment.definitions) });
};
//# sourceMappingURL=replace-user-fragment.js.map